import { Button } from 'UIPackage/MainModule/components/Button';

import styles from './ReplaceAlert.module.scss';

interface IReplaceAlertProps {
  className?: string;
  active?: boolean;
  text: string;
  onHideButtonClick: () => void;
  onReplaceButtonClick: () => void;
  onShowButtonClick: () => void;
}

export function ReplaceAlert({
  className,
  active,
  text,
  onHideButtonClick,
  onReplaceButtonClick,
  onShowButtonClick,
}: IReplaceAlertProps) {
  return (
    <div className={className ? `${styles.ReplaceAlert} ${className}` : styles.ReplaceAlert}>
      <div className={styles.Text}>{text}</div>
      <div className={styles.Buttons}>
        {!active ? (
          <Button
            className={styles.Button}
            text="Показать"
            color="warning"
            size="medium"
            type="button"
            onClick={onShowButtonClick}
          />
        ) : (
          <>
            <Button
              className={styles.Button}
              text="Заменить все"
              color="warning"
              size="medium"
              type="button"
              onClick={onReplaceButtonClick}
            />
            <Button
              className={styles.Button}
              text="Скрыть все"
              color="warning"
              size="medium"
              type="button"
              onClick={onHideButtonClick}
            />
          </>
        )}
      </div>
    </div>
  );
}
